import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveGroup from "../specs/groups/group/WaveGroup";
import { WaveGroupType } from "../specs/groups/group/WaveGroup.types";
import WaveActiveCurationSection from "./curation/WaveActiveCurationSection";
interface WaveGroupsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
export default function WaveGroups(t0) {
  const $ = _c(20);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "tw-rounded-b-xl lg:tw-rounded-b-none";
  const t2 = `tw-relative tw-h-full tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] !== wave) {
    t3 = <WaveActiveCurationSection wave={wave} />;
    $[0] = wave;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-6 tw-px-4 tw-pt-4"><p className="tw-mb-0 tw-text-base tw-font-semibold tw-tracking-tight tw-text-iron-200">General</p></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  let t6;
  if ($[3] !== wave) {
    t5 = <WaveGroup scope={wave.visibility.scope} type={WaveGroupType.VIEW} wave={wave} />;
    t6 = wave.wave.type !== ApiWaveType.Chat && <><WaveGroup scope={wave.participation.scope} type={WaveGroupType.DROP} wave={wave} /><WaveGroup scope={wave.voting.scope} type={WaveGroupType.VOTE} wave={wave} /></>;
    $[3] = wave;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  let t8;
  if ($[6] !== wave) {
    t7 = <WaveGroup scope={wave.chat.scope} type={WaveGroupType.CHAT} wave={wave} />;
    t8 = <WaveGroup scope={wave.wave.admin_group} type={WaveGroupType.ADMIN} wave={wave} />;
    $[6] = wave;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-y-2 tw-px-4">{t5}{t6}{t7}{t8}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t3 || $[15] !== t9) {
    t10 = <div className="no-scrollbar tw-h-full tw-overflow-y-auto tw-overflow-x-hidden"><div className="tw-pb-4">{t3}{t4}{t9}</div></div>;
    $[14] = t3;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t2) {
    t11 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800"><div className={t2}>{t10}</div></div>;
    $[17] = t10;
    $[18] = t2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}